/* Collection filter chips (sections/main-collection.liquid).
   - Filters in place: a chip, an "All" link, a removable pill, Clear all or the sort menu fetches the
     section again (Section Rendering API) and swaps the results in; the URL is updated, Back works.
   - Keeps the Filter panel open and each row's "+" reveal state across updates.
   - Rows with data-reveal show that many chips, then a square "+" reveals the next batch; "−" folds back.
   Without JavaScript the forms still submit (noscript Apply / Sort buttons) and every chip is visible. */
(function () {
  'use strict';

  var ROOT = '[data-collection-root]';

  function rows(root) { return Array.prototype.slice.call(root.querySelectorAll('[data-chip-row]')); }
  function chipsOf(row) { return Array.prototype.slice.call(row.querySelectorAll('.collection-chip--check')); }

  function setShown(row, shown) {
    var n = parseInt(row.getAttribute('data-reveal'), 10) || 0;
    var chips = chipsOf(row);
    var more = row.querySelector('[data-chip-more]');
    if (!n || chips.length <= n) { if (more) more.hidden = true; return; }
    shown = Math.max(n, Math.min(shown, chips.length));
    chips.forEach(function (chip, i) { chip.hidden = i >= shown && !chip.classList.contains('is-active'); });
    row.setAttribute('data-shown', String(shown));
    if (!more) return;
    var all = shown >= chips.length;
    var label = row.getAttribute('data-chip-label') || '';
    more.hidden = false;
    more.textContent = all ? '−' : '+';
    more.setAttribute('aria-expanded', all ? 'true' : 'false');
    more.setAttribute('aria-label', (all ? 'Show fewer ' : 'Show more ') + label);
  }

  function initReveal(root, state) {
    rows(root).forEach(function (row) {
      var n = parseInt(row.getAttribute('data-reveal'), 10) || 0;
      var key = row.getAttribute('data-chip-row');
      setShown(row, (state && state.shown && state.shown[key]) || n);
    });
  }

  function snapshot(root) {
    var s = { shown: {}, open: false };
    rows(root).forEach(function (row) {
      s.shown[row.getAttribute('data-chip-row')] = parseInt(row.getAttribute('data-shown'), 10) || 0;
    });
    var btn = root.querySelector('.collection-toolbar__filter');
    s.open = !!btn && btn.getAttribute('aria-expanded') === 'true';
    return s;
  }

  function restore(root, state, focus) {
    initReveal(root, state);
    if (state.open) {
      var btn = root.querySelector('.collection-toolbar__filter');
      var panel = btn && document.getElementById(btn.getAttribute('aria-controls'));
      if (btn && panel) { panel.hidden = false; btn.setAttribute('aria-expanded', 'true'); }
    }
    if (focus) {
      var el = root.querySelector('input[name="' + focus.name + '"][value="' + focus.value.replace(/"/g, '\\"') + '"]');
      if (el) el.focus({ preventScroll: true });
    }
  }

  function load(root, url, focus, push) {
    var state = snapshot(root);
    var fetchUrl = new URL(url, location.href);
    fetchUrl.searchParams.set('section_id', root.getAttribute('data-section-id'));
    root.setAttribute('aria-busy', 'true');
    fetch(fetchUrl.toString(), { headers: { Accept: 'text/html' }, credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(String(r.status)); return r.text(); })
      .then(function (html) {
        var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector(ROOT);
        if (!fresh) throw new Error('section missing');
        root.innerHTML = fresh.innerHTML;
        restore(root, state, focus);
        if (push !== false) history.pushState({ collectionFilters: true }, '', url);
        root.removeAttribute('aria-busy');
      })
      .catch(function () { location.assign(url); });
  }

  function formUrl(form) {
    var base = (form.getAttribute('action') || location.pathname).split('?')[0];
    return base + '?' + new URLSearchParams(new FormData(form)).toString();
  }

  document.addEventListener('change', function (e) {
    var form = e.target.closest('[data-collection-filters], [data-collection-sort]');
    if (!form) return;
    var root = form.closest(ROOT);
    if (!root) return;
    var focus = e.target.type === 'checkbox' ? { name: e.target.name, value: e.target.value } : null;
    load(root, formUrl(form), focus, true);
  });

  document.addEventListener('click', function (e) {
    var more = e.target.closest('[data-chip-more]');
    if (more) {
      var row = more.closest('[data-chip-row]');
      var n = parseInt(row.getAttribute('data-reveal'), 10) || 0;
      var shown = parseInt(row.getAttribute('data-shown'), 10) || n;
      setShown(row, shown >= chipsOf(row).length ? n : shown + n);
      return;
    }
    var link = e.target.closest('a');
    if (!link) return;
    var root = link.closest(ROOT);
    if (!root) return;
    if (!link.closest('[data-collection-filters]') && !link.closest('.collection-active')) return;
    e.preventDefault();
    load(root, link.getAttribute('href'), null, true);
  });

  window.addEventListener('popstate', function (e) {
    var root = document.querySelector(ROOT);
    if (root && e.state && e.state.collectionFilters) load(root, location.href, null, false);
  });

  Array.prototype.slice.call(document.querySelectorAll(ROOT)).forEach(function (root) { initReveal(root); });
  if (!history.state || !history.state.collectionFilters) {
    history.replaceState({ collectionFilters: true }, '', location.href);
  }
})();
